// ===================================================================
//  Centralni prevodi (SR / EN) za celu landing stranicu.
//  Svaki kljuc ima { sr, en }. Komponente citaju preko t(lang, ...).
// ===================================================================

export const translations = {
  // -------- ZAJEDNICKO --------
  common: {
    back: { sr: "Nazad", en: "Back" },
    learnMore: { sr: "Saznaj više", en: "Learn more" },
    rightsReserved: {
      sr: "Sva prava zadržana",
      en: "All rights reserved",
    },
    poweredBy: {
      sr: "Deo NAŠA Community ekosistema",
      en: "Part of the NAŠA Community ecosystem",
    },
    terms: {
      sr: "Uslovi korišćenja / Uvjeti korištenja",
      en: "Terms & Conditions",
    },
  },

  // -------- HOME --------
  home: {
    tag: {
      sr: "NAŠA MYNER ADRIA",
      en: "NAŠA MYNER ADRIA",
    },
    tagSub: {
      sr: "Digitalna Ekonomija",
      en: "Digital Economy",
    },
    subtitle: {
      sr: "Tehnologija budućnosti za Balkan. Izaberite svoj put u digitalnu ekonomiju — SIGURAN, TRANSPARENTAN I ISPLATIV.",
      en: "Future technology for the Balkans. Choose your path into the digital economy — secure, transparent and profitable.",
    },
    toniniKicker: {
      sr: "Izgradite Svoju Finansijsku Budućnost – Korak po Korak!",
      en: "Build Your Financial Future – Step by Step!",
    },
    toniniDesc: {
      sr: "Zvanična razvojna mreža Adria regije vam donosi svetsku inovaciju. Uđite u digitalnu ekonomiju i osigurajte dugoročni pasivni prihod.",
      en: "The Adria region's official development network brings you world-class innovation. Enter the digital economy and secure long-term passive income.",
    },
    mynerKicker: {
      sr: "Vaš Siguran Ulazak u Digitalnu Ekonomiju",
      en: "Your Safe Entry Into the Digital Economy",
    },
    mynerDesc: {
      sr: "Tehnologija koja radi za vas. Bez rizika, bez skrivenih uslova. Stabilno, dugoročno i potpuno transparentno uvećanje kapitala.",
      en: "Technology that works for you. No risk, no hidden terms. Stable, long-term and fully transparent capital growth.",
    },
    contactTitle: {
      sr: "KONTAKTIRAJTE NAS",
      en: "CONTACT US",
    },
    hubTitle: {
      sr: "NAŠA HUB COMMUNITY",
      en: "NAŠA HUB COMMUNITY",
    },
    hubSub: {
      sr: "Imaš projekat ili ideju? Postani deo ekosistema koji raste.",
      en: "Got a project or idea? Become part of a growing ecosystem.",
    },
    hubBtn: {
      sr: "Otvori NAŠA HUB →",
      en: "Open NAŠA HUB →",
    },
    contactSub: {
      sr: "Tu smo za sva vaša pitanja, javite nam se!",
      en: "We're here for all your questions — get in touch!",
    },
    foundations: {
      sr: "Naši temelji",
      en: "Our Foundations",
    },
  },

  // -------- TONINI BITLAB --------
  tonini: {
    tag: { sr: "// Tonini Finance LTD", en: "// Tonini Finance LTD" },
    lead: {
      sr: "Siguran put do pasivnog prihoda kroz pametne tehnologije — spajamo skoro vek dugu industrijsku tradiciju sa tehnologijom budućnosti.",
      en: "A safe path to passive income through smart technology — combining nearly a century of industrial tradition with the technology of the future.",
    },
    introStrong: { sr: "Tonini BitLab", en: "Tonini BitLab" },
    introRest: {
      sr: " predstavlja stvaran, opipljiv projekat u svetu digitalne ekonomije. Naš cilj je jednostavan: da vam omogućimo siguran prinos – bez tehničkog predznanja i bez stresa.",
      en: " is a real, tangible project in the world of the digital economy. Our goal is simple: to deliver you secure yield – with no technical knowledge and no stress.",
    },
    s1Title: {
      sr: "· Tehnologija budućnosti — Zeleno rudarenje",
      en: "· Technology of the future — Green mining",
    },
    s1p1: {
      sr: "Zaboravite na staro rudarenje, ogromne račune za struju i rizik. Naši serveri nalaze se u sertifikovanim Data centrima u Italiji i Kanadi, i napajaju se isključivo 100 % obnovljivom energijom.",
      en: "Forget old mining, huge electricity bills and risk. Our servers are located in certified data centres in Italy and Canada, powered exclusively by 100 % renewable energy.",
    },
    s1p2pre: {
      sr: "Naš MY.N.E.R. sistem pokreće veštačka inteligencija (AI). Tehnologija optimizuje rad i smanjuje potrošnju električne energije za neverovatnih ",
      en: "Our MY.N.E.R. system is powered by artificial intelligence (AI). The technology optimises performance and reduces electricity consumption by an incredible ",
    },
    s1p2strong: {
      sr: "90 % (sa 3000W na svega 300W)",
      en: "90 % (from 3000W down to just 300W)",
    },
    s2Title: {
      sr: "· Za investitore — Potvrđen rezultat",
      en: "· For investors — Proven results",
    },
    s2pre: {
      sr: "Da naš sistem besprekorno funkcioniše potvrđuje nezavisni revizorski izveštaj ",
      en: "Our system's flawless performance is confirmed by an independent audit report ",
    },
    s2teambit: {
      sr: "(Teambit)",
      en: "(Teambit)",
    },
    s2mid: {
      sr: ", koji dokazuje ostvareni bruto profit od fantastičnih ",
      en: ", proving an achieved gross profit of a fantastic ",
    },
    s2post: {
      sr: " za manje od godinu dana!",
      en: " in less than a year!",
    },
    s3Title: {
      sr: "· Kako vaš novac može da radi za vas?",
      en: "· How can your money work for you?",
    },
    s3o1: {
      sr: "(Zakup mašina na daljinu) — Iznajmite procesorsku moć i ostvarujete  24/7 bez ikakvog vašeg rada. Fiksni, neto i garantovani prinosi od ",
      en: "(Remote machine leasing) — Rent processing power and enjoy 24/7 earnings without any work on your part. Fixed, net and guaranteed returns from ",
    },
    s3o1strong: {
      sr: "7 % do 20 % godišnje",
      en: "7 % to 20 % per year",
    },
    s3o1rest: {
      sr: " (u zavisnosti od dužine ugovora). Vaš ulog vam se na kraju potpuno vraća, a sve je zakonski zaštićeno ",
      en: " (depending on contract length). Your principal is fully returned at the end, and everything is legally protected by a ",
    },
    s3o1contract: {
      sr: " ugovorom (Ugovor o povratnom zakupu).",
      en: " agreement (Sale & Lease Back contract).",
    },
    s3o2: {
      sr: " — Naše mašine rade nečujno i troše struju koliko i jedan običan kućni kompjuter (50–200W). Vaša kuća postaje vaš lični/osobni centar za generisanje prinosa uz minimalne operativne troškove.",
      en: " — Our machines run silently and use as much power as an ordinary home computer (50–200W). Your home becomes your personal yield-generating centre with minimal operating costs.",
    },
    s3o2strong: {
      sr: "2. Fizički MX aparati za vašu kuću",
      en: "2. Physical MX devices for your home",
    },
    s3o3strong: { sr: "3. Projekat Kanada", en: "3. Project Canada" },
    s3o3: {
      sr: " — Naš najunosniji model na ",
      en: " — Our most lucrative model over ",
    },
    s3o3years: { sr: "12 godina", en: "12 years" },
    s3o3rest: {
      sr: ". Uz stabilan redovni prinos, kompanija vas nagrađuje korporativnim tokenima. Investirajte u svoju budućnost lako, brzo, sigurno i jednostavno.",
      en: ". Alongside a stable regular return, the company rewards you with corporate tokens. Invest in your future easily, quickly, safely and simply.",
    },
    s4Title: {
      sr: "· Poslovna prilika — Izgradite karijeru sa nama!",
      en: "· Business opportunity — Build a career with us!",
    },
    s4p1: {
      sr: "Tonini BitLab vam nudi priliku da postanete naš partner kroz program mrežnog marketinga (network marketing). Konkurs za agente je potpuno besplatan. Možete ostvariti ozbiljne provizije i izgraditi sopstveni/vlastiti biznis čak i bez lične/osobne kupovine proizvoda!",
      en: "Tonini BitLab offers you the chance to become our partner through a network marketing programme. Applying as an agent is completely free. You can earn serious commissions and build your own business even without personally purchasing products!",
    },
    s4p2: {
      sr: "Promenite akciju – promenite rezultat! Vaša svakodnevica može postati vaš prinos.",
      en: "Change the action – change the result! Your everyday life can become your yield.",
    },
    videoBtn: {
      sr: "Pogledajte video prezentaciju",
      en: "Watch the video presentation",
    },
    telegramBtn: {
      sr: "Pridružite se zajednici na Discordu",
      en: "Join our community on Discord",
    },
  },

  // -------- NASA MYNER --------
  myner: {
    tag: { sr: "// NAŠA Community", en: "// NAŠA Community" },
    discordTag: { sr: "// Zajednica i podrška", en: "// Community & support" },
    discordBtn: { sr: "Zajednica na Discordu", en: "Community on Discord" },
    discordSub: { sr: "Novosti, tutorijali i podrška tima na jednom mestu", en: "News, tutorials and team support in one place" },
    discordGuide: { sr: "Prvi put na Discordu? Pogledajte uputstvo", en: "First time on Discord? Read the guide" },
    lead: {
      sr: "Tehnologija koja radi za vas. Bez rizika, bez skrivenih uslova/uvjeta.",
      en: "Technology that works for you. No risk, no hidden terms.",
    },
    intro1pre: {
      sr: "NAŠA MYNER je giveaway inicijativa NAŠA Community ekosistema — nezavisna platforma kreirana za Adria region. Naš cilj je jednostavan: da svakom članu zajednice omogućimo put do fizičkog Myner uređaja kroz transparentne giveaway cikluse.",
      en: "NAŠA MYNER is a giveaway initiative of the NAŠA Community ecosystem — an independent platform built for the Adria region. Our goal is simple: to give every community member a path to owning a physical Myner device through transparent giveaway cycles.",
    },
    intro1strong: { sr: "NAŠA MYNER", en: "NAŠA MYNER" },
    intro1mid: {
      sr: " ",
      en: " ",
    },
    intro1strong2: {
      sr: "",
      en: "",
    },
    intro1rest: {
      sr: "",
      en: "",
    },
    intro2: {
      sr: "Kupite tiket, učestvujete u izvlačenju — a ako ne osvojite uređaj, vaši „NAŠA Tokeni“ nastavljaju da rade za vas kroz PAMM rentni fond ili Arbitražu PRO. Vaš ulog nikada ne propada.",
      en: "Buy a ticket, join the draw — and if you don't win the device, your „NAŠA Tokens“ keep working for you through the PAMM rental fund or Arbitrage PRO. Your stake never goes to waste.",
    },
    s1Title: { sr: "· Zašto NAŠA MYNER?", en: "· Why NAŠA MYNER?" },
    s1p: {
      sr: "Naše tržište traži dokaze, a ne priče. Zato smo izbacili ljudski faktor iz odlučivanja i poverili vaš kapital matematici i blockchain tehnologiji.",
      en: "Our market wants proof, not stories. That's why we removed the human factor from decision-making and entrusted your capital to mathematics and blockchain technology.",
    },
    s2Title: {
      sr: "· Apsolutna transparentnost — Bitcoin Block sistem",
      en: "· Absolute transparency — Bitcoin Block system",
    },
    s2pre: { sr: "Kupovinom tiketa (", en: "By buying a ticket (" },
    s2strong1: {
      sr: "25€ = 25 NAŠA Tokena",
      en: "€25 = 25 NAŠA Tokens",
    },
    s2mid: {
      sr: ") postajete deo naših Giveaway ciklusa za Myner mašine. Izvlačenje dobitnika se oslanja isključivo na javne ",
      en: ") you become part of our Giveaway cycles for Myner machines. The winner draw relies exclusively on public ",
    },
    s2strong2: {
      sr: "Hash kodove sa Bitcoin mreže",
      en: "hash codes from the Bitcoin network",
    },
    s2rest: {
      sr: ". Manipulacija je matematički nemoguća. Sve je javno i proverljivo u sekundi.",
      en: ". Manipulation is mathematically impossible. Everything is public and verifiable in a second.",
    },
    s3Title: {
      sr: "· “Zero-Loss” Inovacija — Vaš ulog nikada ne propada",
      en: "· “Zero-Loss” Innovation — Your stake is never lost",
    },
    s3pre: {
      sr: "Ovo nije igra na sreću, već pametno učešće. Ukoliko u ciklusu ne osvojite MYNER mašinu, ",
      en: "This is not gambling, this is smart participation. If you don't win a Myner machine in a cycle, ",
    },
    s3strong1: {
      sr: "ne gubite novac",
      en: "you do not lose your money",
    },
    s3mid: {
      sr: ". Vaši NAŠA Tokeni automatski postaju udeo u ",
      en: ". Your NAŠA Tokens automatically become your share in our ",
    },
    s3strong2: {
      sr: "PAMM rentnom fondu",
      en: "PAMM rental fund",
    },
    s3mid2: {
      sr: " ili vam otključava vrata za ",
      en: " or unlock the door to ",
    },
    s3strong3: { sr: "Arbitražu PRO", en: "Arbitrage PRO" },
    s3rest: {
      sr: " (sistem za automatizovano trgovanje). Svaki vaš cent zadržava vrednost i nastavlja da generiše prinos.",
      en: " (an automated trading system). Every cent you invest keeps its value and continues to generate yield.",
    },
    s4Title: {
      sr: "· Aktivna Adria Zajednica",
      en: "· Active Adria Community",
    },
    s4p: {
      sr: "Sistem nagrađuje lojalnost. Za svakog novog aktivnog člana koji dođe preko vašeg pozivnog (refferal) linka, platforma vas automatski nagrađuje dodatnim NAŠA Tokenima. Raste zajednica, raste i vaš kapital.",
      en: "The system rewards loyalty. For each new active member who joins via your invite link, the platform automatically rewards you with extra NAŠA Tokens. As the community grows, so does your capital.",
    },
    stepsTitle: {
      sr: "Kako započeti?",
      en: "How to start?",
    },
    stepsHighlight: {
      sr: "Tri koraka.",
      en: "Three steps.",
    },
    step1Title: {
      sr: "Registracija i kontrolna tabla",
      en: "Registration and dashboard",
    },
    step1Body: {
      sr: "Prijavite se i pristupite svom ličnom “supercomputer” interfejsu. Sve vaše investicije, tokeni i statistika nalaze se na jednom mestu — pregledno i jasno.",
      en: "Sign up and access your personal “supercomputer” interface. All your investments, tokens and statistics are in one place — clear and simple.",
    },
    step2Title: {
      sr: "Kupovina tiketa u USDT",
      en: "Buying tickets in USDT",
    },
    step2Body: {
      sr: "Sve operacije obavljaju se u stabilnoj valuti USDT (Tether) na Tron (TRC20) mreži. Paritet je fiksiran: 1 EUR ≈ 1 USDT. Brzo, jeftino i maksimalno sigurno.",
      en: "All operations are carried out in the stable currency USDT (Tether) on the Tron (TRC20) network. The parity is fixed: 1 EUR ≈ 1 USDT. Fast, cheap and maximally secure.",
    },
    step3Title: {
      sr: "Pratite svoj progres",
      en: "Track your progress",
    },
    step3Body: {
      sr: "Učestvujte u ciklusima, pratite sakupljanje sredstava uživo i gledajte kako vaši tokeni rade za vas — bilo kroz hardver ili kroz Arbitražu PRO.",
      en: "Take part in cycles, follow fundraising live and watch your tokens work for you — whether through hardware or through Arbitrage PRO.",
    },
    s5Title: {
      sr: "· Nova era digitalnog poslovanja",
      en: "· A new era of digital business",
    },
    s5p1pre: {
      sr: "NAŠA MYNER nije samo platforma — to je ekosistem. Dizajniran sa ",
      en: "NAŠA MYNER is not just a platform — it's an ecosystem. Designed with an ",
    },
    s5p1strong: {
      sr: "italijanskim osećajem za kvalitet",
      en: "Italian sense of quality",
    },
    s5p1rest: {
      sr: " i vizuelni identitet, a suštinski prilagođen balkanskoj potrebi za konkretnim i opipljivim rezultatima.",
      en: " and visual identity, yet fundamentally adapted to the Balkan need for concrete and tangible results.",
    },
    s5p2: {
      sr: "Investirajte u tehnologiju. Uđite u sistem u kom kapital uvek ima svrhu.",
      en: "Invest in technology. Enter a system where capital always has a purpose.",
    },
    joinBtn: {
      sr: "Pridruži se NAŠA zajednici — Kupi svoj prvi tiket",
      en: "Join the NAŠA community — buy your first ticket",
    },
  },
};

// Helper: vrati prevod za dati kljuc i jezik.
export function tr(section, key, lang) {
  const node = translations[section] && translations[section][key];
  if (!node) return "";
  return node[lang] || node.sr || "";
}
